import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ModalConfirm } from "tamtam-components";
import Select from "react-select";
import { toast } from "react-toastify";

import Loader from "../../common/Loader";
import Button from "../../common/Button";
import FormInput from "../../common/FormInput";
import _ from "../../../i18n";
import {
  saveGoPeopleClient,
  saveGoPeopleContact,
  updateGoPeopleClient,
  getGoPeopleFoldersByUen,
  saveGoPeopleFolderContact,
  searchGoPeopleCommunityByEntity,
} from "../../../api";
import { LANGUAGES, LEGAL_FORM, SELECT_STYLES } from "../../../config";
import {
  validateEmail,
  validateUen,
  formatPhone,
  formatHidePhone,
  obscureEmail,
} from "../../../utils";
import styles from "./Client.module.scss";

let isFetchingEmail = false;

const ClientForm = (props) => {
  const auth = useSelector((state) => state.auth);
  const [isSaving, setIsSaving] = useState(false);
  const [isFetchingUser, setIsFetchingUser] = useState(false);
  const [isFetchingCompany, setIsFetchingCompany] = useState(false);
  const [isValidForm, setIsValidForm] = useState(false);
  const [fetchedFolder, setFetchedFolder] = useState(null);
  const [showConfirmFolder, setShowConfirmFolder] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [disableContactFields, setDisableContactFields] = useState(false);
  const { goPeopleCommunityId, jwtToken, goPeopleOrganizationId } = auth;
  let saveInterval;

  const initErrors = {
    uen: "",
    name: "",
    legalForm: "",
    languagePreferences: "",
    contactEmail: "",
    contactFirstName: "",
    contactLastName: "",
    contactPhone: "",
  };
  const initData = {
    id: "",
    uen: "",
    name: "",
    legalForm: { value: "SRL", label: LEGAL_FORM.SRL },
    languagePreferences: [LANGUAGES[0]],
    contactId: "",
    contactEmailId: "",
    contactEmail: "",
    contactEmailValue: "",
    contactFirstName: "",
    contactLastName: "",
    contactPhone: "",
    contactPhoneId: "",
    contactPhoneValue: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const [data, setData] = useState(initData);

  useEffect(() => {
    if (props.currentItem) {
      let languagePreferences = [];
      if (
        props.currentItem.languages &&
        props.currentItem.languages.length > 0
      ) {
        props.currentItem.languages.forEach((lng) => {
          LANGUAGES.forEach((i) => {
            if (i.value === lng) {
              languagePreferences.push(i);
            }
          });
        });
      }

      let legalRepresentative = props.currentItem.contacts.filter(
        (c) => c.role_type === "LEGAL_REPRESENTATIVE"
      )[0];
      setData({
        id: props.currentItem.id,
        uuid: props.currentItem.uuid,
        uen: props.currentItem.uen,
        name: props.currentItem.folder_name,
        legalForm: {
          value: props.currentItem.legal_form,
          label: LEGAL_FORM[props.currentItem.legal_form],
        },
        languagePreferences: languagePreferences ? languagePreferences : "",
        contactId: legalRepresentative?.contact_id,
        contactEmail: legalRepresentative?.emails?.length
          ? legalRepresentative?.emails[0]
          : "",
        contactEmailValue: legalRepresentative?.emails?.length
          ? legalRepresentative?.emails[0]
          : "",
        contactFirstName: legalRepresentative
          ? legalRepresentative.first_name
          : "",
        contactLastName: legalRepresentative
          ? legalRepresentative.last_name
          : "",
        contactPhone: legalRepresentative?.phones?.length
          ? legalRepresentative?.phones[0]
          : "",
        contactPhoneValue: legalRepresentative?.phones?.length
          ? legalRepresentative?.phones[0]
          : "",
      });
      setDisableFields(false);
    }
  }, [props.currentItem]);

  useEffect(() => {
    setIsValidForm(
      data.uen.length === 0 ||
        data.name.length === 0 ||
        errors.uen ||
        errors.name ||
        errors.legalForm ||
        errors.contactEmail ||
        errors.contactFirstName ||
        errors.contactLastName
        ? false
        : true
    );
  }, [
    data.uen,
    data.name,
    errors.uen,
    errors.name,
    errors.legalForm,
    errors.languagePreferences,
    errors.contactEmail,
    errors.contactFirstName,
    errors.contactLastName,
  ]);

  const handleKeyUp = (fieldName, fieldValue) => {
    let value = "";
    if (fieldValue.length === 0 && fieldName !== "contactPhone") {
      value = _("required_field");
    } else {
      switch (fieldName) {
        case "uen":
          if (!validateUen(fieldValue)) {
            value = _("validate_uen");
          }
          break;
        case "name":
          if (fieldValue.length < 2) {
            value = _("required_2_characters");
          }
          break;
        case "contactLastName":
          if (fieldValue.length < 2) {
            value = _("required_2_characters");
          }
          break;
        case "contactFirstName":
          if (fieldValue.length < 2) {
            value = _("required_2_characters");
          }
          break;
        case "contactEmail":
          if (!validateEmail(fieldValue)) {
            value = _("validate_email");
          }
          break;
        case "contactPhone":
          if (fieldValue.length < 10) {
            value = _("required_field");
          }
          break;
        default:
          break;
      }
    }
    setErrors({ ...errors, [fieldName]: value });
  };

  const handleEmailChange = (name, value) => {
    if (value.length === 0)
      setErrors({ ...errors, [name]: _("required_field") });
    else if (value.length > 0 && !validateEmail(value)) {
      setErrors({ ...errors, email: _("validate_email") });
    }
    setData({ ...data, [name]: value, contactEmailValue: value });
  };

  const createContactFolderRole = (folderUuid) => {
    let contactData = {
      email: data.contactEmail,
      first_name: data.contactFirstName,
      last_name: data.contactLastName,
      role_type: "LEGAL_REPRESENTATIVE",
      telephone: data.contactPhone,
      contact_id: data.contactId,
    };
    if (data.contactEmail) {
      if (data.contactId) {
        saveGoPeopleFolderContact(goPeopleCommunityId, folderUuid, [
          contactData,
        ]).then((resp) => {
          setIsSaving(false);
          props.afterSave();
          setData(initData);
          props.setCurrentItem(null);
          toast.success(_("successfully_added"));
          clearInterval(saveInterval);
          if (props.setSideBar) {
            props.setSideBar("DEFAULT");
          }
        });
      } else {
        let contactPerData = {
          emails: [data.contactEmail],
          first_name: data.contactFirstName,
          last_name: data.contactLastName,
          community_id: goPeopleCommunityId,
          phones: data.contactPhone ? [data.contactPhone] : [],
          language: data.languagePreferences.map((lng) => lng.value)[0],
        };
        saveGoPeopleContact(goPeopleCommunityId, contactPerData).then(
          (contactResponse) => {
            contactData = {
              ...contactData,
              contact_id: contactResponse.uuid,
            };
            saveGoPeopleFolderContact(goPeopleCommunityId, folderUuid, [
              contactData,
            ]).then((resp) => {
              setIsSaving(false);
              props.afterSave();
              setData(initData);
              props.setCurrentItem(null);
              toast.success(_("successfully_added"));
              clearInterval(saveInterval);
              if (props.setSideBar) {
                props.setSideBar("DEFAULT");
              }
            });
          }
        );
      }
    }
  };

  const handleUpdate = async () => {
    if (!isFetchingEmail && !isSaving) {
      let clientData = {
        uen: data.uen,
        organization_id: goPeopleOrganizationId,
        community_id: goPeopleCommunityId,
      };
      if (data.name !== props.currentItem.folder_name) {
        clientData = {
          ...clientData,
          folder_name: data.name,
        };
      }
      if (data.legalForm.value !== props.currentItem.legal_form) {
        clientData = {
          ...clientData,
          legal_form: data.legalForm.value,
        };
      }

      if (
        data.languagePreferences.filter((value) =>
          props.currentItem.languages?.includes(value.value)
        ).length === data.languagePreferences.length &&
        data.languagePreferences.length === props.languages
      ) {
        clientData = {
          ...clientData,
          languages: data.languagePreferences.map((lng) => lng.value),
        };
      }
      let legalRepresentative = props.currentItem.contacts.filter(
        (c) => c.role_type === "LEGAL_REPRESENTATIVE"
      )[0];
      let promises = [];
      if (data.contactEmail !== legalRepresentative?.emails[0]) {
        let contactRoleData = {
          email: data.contactEmail,
          first_name: data.contactFirstName,
          last_name: data.contactLastName,
          role_type: "LEGAL_REPRESENTATIVE",
          telephone: data.contactPhone,
        };
        if (!data.contactId) {
          let contactData = {
            first_name: data.contactFirstName,
            last_name: data.contactLastName,
            emails: [data.contactEmail],
          };
          if (data.contactPhone && data.contactPhone !== "") {
            contactData = {
              ...contactData,
              phones: [data.contactPhone],
            };
          }
          saveGoPeopleContact(goPeopleCommunityId, contactData).then(
            (contactResponse) => {
              contactRoleData = {
                ...contactRoleData,
                contact_id: contactResponse.uuid,
              };
              let contactPromise = saveGoPeopleFolderContact(
                goPeopleCommunityId,
                props.currentItem.uuid,
                [contactRoleData]
              );
              promises += [contactPromise];
            }
          );
        } else {
          let contactPromise = saveGoPeopleFolderContact(
            goPeopleCommunityId,
            props.currentItem.uuid,
            [contactRoleData]
          );
          promises += [contactPromise];
        }
      }
      if (Object.keys(clientData).length > 1) {
        let folderPromise = updateGoPeopleClient(
          jwtToken,
          goPeopleCommunityId,
          props.currentItem.uuid,
          clientData
        );
        promises += [folderPromise];
      }
      const response = await Promise.all(promises)
        .then((values) => {
          setIsSaving(false);
          props.afterSave();
          setData(initData);
          props.setCurrentItem(null);
          toast.success(_("successfully_added"));
          clearInterval(saveInterval);
          if (props.setSideBar) {
            props.setSideBar("DEFAULT");
          }
        })
        .catch((e) => {
          setIsSaving(false);
          clearInterval(saveInterval);
          if (
            e.response &&
            e.response.data &&
            e.response.data.errors &&
            e.response.data.errors.length > 0
          )
            toast.error(_(e.response.data.errors[0].message));
          else toast.error(_("error"));
        });
    }
  };

  const handleSave = () => {
    if (!isFetchingEmail && !isSaving) {
      let clientData = {
        uen: data.uen,
        folder_name: data.name,
        legal_form: data.legalForm.value,
        languages: data.languagePreferences.map((lng) => lng.value),
      };
      clearInterval(saveInterval);
      setIsSaving(true);

      if (fetchedFolder) {
        createContactFolderRole(fetchedFolder.uuid);
      } else {
        saveGoPeopleClient(
          jwtToken,
          goPeopleCommunityId,
          goPeopleOrganizationId,
          clientData
        )
          .then((folderResponse) => {
            createContactFolderRole(folderResponse.uuid);
          })
          .catch((e) => {
            setIsSaving(false);
            clearInterval(saveInterval);
            if (
              e.response &&
              e.response.data &&
              e.response.data.errors &&
              e.response.data.errors.length > 0
            )
              toast.error(_(e.response.data.errors[0].message));
            else toast.error(_("error"));
          });
      }
    }
  };

  const save = () => {
    setIsSaving(true);
    if (props.currentItem?.uuid) {
      saveInterval = setInterval(handleUpdate, 800);
    } else {
      saveInterval = setInterval(handleSave, 800);
    }
  };

  const handleUenKeyUp = (name, value) => {
    let error = "";
    if (!validateUen(value)) error = _("validate_uen");
    else error = "";
    if (value.length === 0) error = _("required_field");
    setErrors({ ...errors, [name]: error });
  };

  const handleConfirmFolderByUen = (folder = null) => {
    if (!folder) {
      folder = fetchedFolder;
    }
    let folderData = {
      id: folder.id,
      uen: folder.uen,
      name: folder.name,
    };
    if (folder.legalForm) {
      folderData.legalForm = {
        value: folder.legalForm,
        label: LEGAL_FORM[folder.legalForm],
      };
    }
    if (folder.legalRepresentative) {
      let emailResult = folder.legalRepresentative.email.filter(
        (i) => i.email === folder.legalRepresentative.mainEmail
      );
      let phoneResult = folder.legalRepresentative.phone.filter(
        (i) => i.number === folder.legalRepresentative.mainPhone
      );

      folderData = {
        ...folderData,
        contactId: folder.legalRepresentative.id,
        contactEmailId: emailResult[0].id,
        contactEmail: folder.legalRepresentative.mainEmail,
        contactEmailValue: obscureEmail(folder.legalRepresentative.mainEmail),
        contactFirstName: folder.legalRepresentative.firstName,
        contactLastName: folder.legalRepresentative.lastName,
        contactPhone: folder.legalRepresentative.mainPhone,
        contactPhoneValue: formatHidePhone(
          folder.legalRepresentative.mainPhone
        ),
        contactPhoneId:
          phoneResult && phoneResult.length > 0 ? phoneResult[0].id : "",
      };
    }
    setData({
      ...data,
      ...folderData,
    });
    setErrors({ ...errors, name: "" });
    setDisableFields(true);
    setShowConfirmFolder(false);
  };

  const handleUenBlur = (value) => {
    if (validateUen(value)) {
      setErrors({ ...errors, uen: "" });
      setIsFetchingCompany(true);
      getGoPeopleFoldersByUen(
        jwtToken,
        goPeopleCommunityId,
        value.replace(/\.|\s|BE|be/g, "")
      )
        .then((response) => {
          if (response.folder_count > 0) {
            setFetchedFolder(response.folders[0]);
            handleConfirmFolderByUen(response.folders[0]);
            let languagePreferences = [];
            if (
              response.folders[0].languages &&
              response.folders[0].languages.length > 0
            ) {
              response.folders[0].languages.forEach((lng) => {
                LANGUAGES.forEach((i) => {
                  if (i.value === lng) {
                    languagePreferences.push(i);
                  }
                });
              });
            }
            let legalRepresentativeRole = response.contactsFolderRole?.filter(
              (cont) =>
                cont.role_type === "LEGAL_REPRESENTATIVE" &&
                cont.folder_id === response.folders[0].uuid
            );
            let legalRepresentative =
              legalRepresentativeRole && legalRepresentativeRole.length
                ? response.contacts.filter(
                    (contact) =>
                      contact.uuid === legalRepresentativeRole[0].contact_id
                  )[0]
                : null;
            setData({
              ...data,
              uen: response.folders[0].uen,
              name: response.folders[0].folder_name,
              legalForm: {
                value: response.folders[0].legal_form,
                label: LEGAL_FORM[response.folders[0].legal_form],
              },
              languagePreferences: languagePreferences
                ? languagePreferences
                : "",
              contactId: legalRepresentative?.uuid,
              contactEmail: legalRepresentative?.emails?.length
                ? legalRepresentative?.emails[0]
                : "",
              contactEmailValue: legalRepresentative?.emails?.length
                ? legalRepresentative?.emails[0]
                : "",
              contactFirstName: legalRepresentative
                ? legalRepresentative.first_name
                : "",
              contactLastName: legalRepresentative
                ? legalRepresentative.last_name
                : "",
              contactPhone: legalRepresentative?.phones?.length
                ? legalRepresentative?.phones[0]
                : "",
              contactPhoneValue: legalRepresentative?.phones?.length
                ? legalRepresentative?.phones[0]
                : "",
            });
            if (legalRepresentative) {
              setDisableContactFields(true);
            }
            setErrors({ ...errors, name: "" });
          } else {
            setDisableFields(false);
            setDisableContactFields(false);
            setData({ ...initData, uen: value });
          }
        })
        .catch((e) => {
          if (fetchedFolder) {
            setData({
              ...data,
              id: "",
              name: "",
              legalForm: { value: "SRL", label: LEGAL_FORM.SRL },
              languagePreferences: [LANGUAGES[0]],
              contactId: "",
              contactEmailId: "",
              contactEmail: "",
              contactEmailValue: "",
              contactFirstName: "",
              contactLastName: "",
              contactPhone: "",
              contactPhoneId: "",
              contactPhoneValue: "",
            });
          }
          setFetchedFolder(null);
          if (e.response && e.response.status === 404) {
            getGoPeopleFoldersByUen(jwtToken, goPeopleCommunityId, value)
              .then((res) => {
                const resp = res.data.data;
                if (resp.isValid) {
                  setData({
                    ...data,
                    name: resp.name,
                  });
                  setErrors({ ...errors, name: "" });
                }
                // else {
                //   setData({ ...data, name: "" });
                // }
              })
              .finally(() => {
                setIsFetchingCompany(false);
                setDisableFields(false);
              });
          }
        })
        .finally(() => {
          setIsFetchingCompany(false);
        });
    } else {
      if (value.length === 0)
        setErrors({ ...errors, uen: _("required_field") });
      else setErrors({ ...errors, uen: _("validate_uen") });
    }
  };

  const handlePhoneBlur = (name, value) => {
    if (value.length > 0 && value.length < 6)
      setErrors({ ...errors, [name]: _("required_field") });
    else {
      setData({ ...data, contactPhone: formatPhone(value) });
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleBlur = (name, value) => {
    if (value.length === 0)
      setErrors({ ...errors, [name]: _("required_field") });
    else setErrors({ ...errors, [name]: "" });
  };

  const handleLanguageChange = (option) => {
    if (option.length === 0)
      setErrors({ ...errors, languagePreferences: _("required_field") });
    else setErrors({ ...errors, languagePreferences: "" });
    setData({ ...data, languagePreferences: option });
  };

  const handleChange = (name, value) => {
    if (name === "contactPhone") {
      setData({ ...data, [name]: value, contactPhoneValue: value });
    } else {
      if (value.length === 0) {
        setErrors({ ...errors, [name]: _("required_field") });
      } else {
        setErrors({ ...errors, [name]: "" });
      }
      setData({ ...data, [name]: value });
    }
  };

  const handleEmailBlur = async (e) => {
    if (data.contactEmail.length > 0 && validateEmail(data.contactEmail)) {
      setIsFetchingUser(true);
      isFetchingEmail = true;
      searchGoPeopleCommunityByEntity(
        jwtToken,
        goPeopleCommunityId,
        "contact",
        data.contactEmail,
        0,
        "emails",
        true
      )
        .then((resp) => {
          if (resp.total > 0) {
            setDisableContactFields(true);
            setData({
              ...data,
              contactFirstName: resp.results[0].firstname,
              contactLastName: resp.results[0].lastname,
              contactPhone: resp.results[0].phones?.length
                ? resp.results[0].phones[0]
                : "",
              contactPhoneValue: resp.results[0].phones?.length
                ? formatHidePhone(resp.results[0].phones[0])
                : "",
              contactId: resp.results[0].uuid,
            });
          } else {
            setDisableContactFields(false);
            setData({
              ...data,
              contactFirstName: "",
              contactLastName: "",
              contactPhone: "",
              contactPhoneValue: "",
              contactId: null,
            });
          }
          setIsFetchingUser(false);
          isFetchingEmail = false;
        })
        .catch((e) => {
          setIsFetchingUser(false);
          setDisableContactFields(false);
          isFetchingEmail = false;
          setData({ ...data, contactEmailId: "", contactPhoneId: "" });
        });
    }
  };

  return (
    <div className={props.addFormClass ? styles.form : ""}>
      <div
        className={`${styles.form_content} ${
          props.addFormClass && styles.form_content_pad
        } ${isFetchingUser && styles.loading}`}
        style={{ position: "relative" }}
      >
        {isFetchingCompany && <div className="lmask"></div>}
        <div className={styles.titles}>
          <h4>Ajout Manuel d'un client</h4>
          <p>Remplissez les champs pour ajouter un client</p>
        </div>
        <FormInput
          name="uen"
          required={true}
          info={_("uen_info")}
          label={_("business_number")}
          autoComplete="none"
          error={errors.uen}
          value={data.uen}
          placeholder="BE XXXX.XXX.XXX"
          onKeyUp={(e) => handleUenKeyUp(e.target.name, e.target.value)}
          handleBlur={(e) => handleUenBlur(e.target.value)}
          onChange={(e) => handleChange(e.target.name, e.target.value)}
        />

        <FormInput
          name="name"
          value={data.name}
          required={true}
          label={_("Nom d’entreprise")}
          error={errors.name}
          autoComplete="none"
          handleBlur={(e) => handleBlur(e.target.name, e.target.value)}
          onChange={(e) => handleChange(e.target.name, e.target.value)}
          disabled={disableFields}
        ></FormInput>

        <div className="ttp-form-group">
          <label className="ttp-label">{_("legal_form")}</label>
          <Select
            styles={SELECT_STYLES}
            options={Object.entries(LEGAL_FORM).map(([k, v]) => {
              return { value: k, label: v };
            })}
            isSearchable={false}
            required={true}
            value={data.legalForm}
            onChange={(e) => setData({ ...data, legalForm: e })}
            isDisabled={disableFields}
          />
        </div>

        <div className="ttp-form-group">
          <label className="ttp-label">{_("language")}</label>
          <Select
            isMulti
            styles={SELECT_STYLES}
            options={LANGUAGES}
            isSearchable={false}
            required={true}
            value={data.languagePreferences}
            onChange={(e) => handleLanguageChange(e)}
            isDisabled={disableFields}
          />
          {errors.languagePreferences && (
            <div className="ttp-error">{errors.languagePreferences}</div>
          )}
        </div>

        <div className={styles.linkedContact}>{_("linked_contact")}</div>
        <FormInput
          name="contactEmail"
          required={true}
          label={_("email_address")}
          autoComplete="none"
          error={errors.contactEmail}
          value={data.contactEmailValue}
          handleBlur={(e) => handleEmailBlur(e)}
          onKeyUp={(e) => handleKeyUp(e.target.name, e.target.value)}
          onChange={(e) => handleEmailChange(e.target.name, e.target.value)}
          disabled={disableContactFields}
        />
        <div className="grid-x grid-margin-x">
          <div className="cell small-12 medium-6">
            <FormInput
              name="contactLastName"
              required={true}
              label={_("lastname")}
              autoComplete="none"
              error={errors.contactLastName}
              value={data.contactLastName}
              handleBlur={(e) => handleBlur(e.target.name, e.target.value)}
              onKeyUp={(e) => handleKeyUp(e.target.name, e.target.value)}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
              disabled={disableContactFields}
            />
          </div>
          <div className="cell small-12 medium-6">
            <FormInput
              name="contactFirstName"
              required={true}
              label={_("firstname")}
              autoComplete="none"
              error={errors.contactFirstName}
              value={data.contactFirstName}
              handleBlur={(e) => handleBlur(e.target.name, e.target.value)}
              onKeyUp={(e) => handleKeyUp(e.target.name, e.target.value)}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
              disabled={disableContactFields}
            />
          </div>
        </div>
        <FormInput
          name="contactPhone"
          // required={true}
          label={_("phone_number")}
          placeholder="+32XXXXXXXX"
          autoComplete="none"
          value={data.contactPhoneValue}
          error={errors.contactPhone}
          onKeyUp={(e) => handleKeyUp(e.target.name, e.target.value)}
          onChange={(e) => handleChange(e.target.name, e.target.value)}
          handleBlur={(e) => handlePhoneBlur(e.target.name, e.target.value)}
          disabled={disableContactFields}
        />
      </div>
      <div className={styles.actions}>
        <Button
          variant="default"
          onClick={(e) => {
            setData(initData);
            setErrors(initErrors);
            if (props.setSideBar) props.setSideBar("DEFAULT");
          }}
        >
          {_("cancel")}
        </Button>
        {isSaving ? (
          <Button
            variant="primary"
            style={{ paddingTop: "15px", paddingBottom: "15px" }}
          >
            <Loader
              style={{
                height: "10px",
              }}
              color={"#fff"}
            />
          </Button>
        ) : (
          <Button disabled={!isValidForm} onClick={() => save()}>
            {props.currentItem ? _("edit") : _("add")}
          </Button>
        )}
      </div>

      <ModalConfirm
        type="publish"
        isOpen={showConfirmFolder}
        onCancel={() => {
          setData(initData);
          setShowConfirmFolder(false);
          setDisableFields(false);
        }}
        onConfirm={() => handleConfirmFolderByUen()}
        title={_("add_confirm")}
        text={_("text_add_exist_client")}
        labelNo={_("no")}
        labelYes={_("yes")}
        labelError={_("error")}
      />
    </div>
  );
};

export default ClientForm;
